import React from 'react';
import { Clock, Users, ArrowRight } from 'lucide-react';
import { Avatar } from '../ui/Avatar';
import { Badge } from '../ui/Badge';
import { Button } from '../ui/Button';
import { Workspace } from '../../types/workspace';
interface WorkspacesListProps {
  workspaces: Workspace[];
  onSelect: (id: string) => void;
}
export function WorkspacesList({
  workspaces,
  onSelect
}: WorkspacesListProps) {
  if (workspaces.length === 0) {
    return <div className="p-8 text-center" data-id="element-199">
        <p className="text-gray-500" data-id="element-200">No workspaces found</p>
        <p className="text-gray-500 text-sm mt-1" data-id="element-201">
          Create a new workspace to get started
        </p>
      </div>;
  }
  return <div className="divide-y divide-gray-200" data-id="element-202">
      {workspaces.map(workspace => <div key={workspace.id} className="p-4 hover:bg-gray-50 transition-colors" data-id="element-203">
          <div className="flex justify-between" data-id="element-204">
            <div data-id="element-205">
              <h3 className="text-lg font-medium text-gray-900" data-id="element-206">
                {workspace.name}
              </h3>
              <p className="text-sm text-gray-500 mt-1" data-id="element-207">
                {workspace.description}
              </p>
              <div className="mt-4 flex items-center space-x-6" data-id="element-208">
                <div className="flex items-center text-sm text-gray-500" data-id="element-209">
                  <Clock size={16} className="mr-1" data-id="element-210" />
                  <span data-id="element-211">Updated {workspace.lastUpdated}</span>
                </div>
                <div className="flex items-center text-sm text-gray-500" data-id="element-212">
                  <Users size={16} className="mr-1" data-id="element-213" />
                  <span data-id="element-214">{workspace.collaborators.length} collaborators</span>
                </div>
              </div>
            </div>
            <div className="flex flex-col items-end justify-between" data-id="element-215">
              <Badge variant={workspace.status === 'Active' ? 'success' : 'default'} data-id="element-216">
                {workspace.status}
              </Badge>
              <div className="mt-4 flex space-x-2 items-center" data-id="element-217">
                <div className="flex -space-x-2" data-id="element-218">
                  {workspace.collaborators.slice(0, 3).map((user, index) => <Avatar key={index} name={user.name} src={user.avatar} size="sm" data-id="element-219" />)}
                  {workspace.collaborators.length > 3 && <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-xs text-gray-600" data-id="element-220">
                      +{workspace.collaborators.length - 3}
                    </div>}
                </div>
                <Button variant="ghost" size="sm" onClick={() => onSelect(workspace.id)} icon={<ArrowRight size={16} data-id="element-222" />} data-id="element-221">
                  Open
                </Button>
              </div>
            </div>
          </div>
        </div>)}
    </div>;
}